import React, { useState } from "react";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import classnames from "classnames";
import ReadOnly from "./DataEntry/ReadOnly";
import FileInfo from "./FileInfo";
import Chat from "./Chat";
import { SpinnerBlack } from "components/Spinner";
import Translate from "helpers/Translate";

export const ToolBar = () => {
  const [showReadOnly, setShowReadOnly] = useState(true);
  const [showFileInfo, setShowFileInfo] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const fileInfo = useSelector(state => state.file.getFile);
  const isLoadingFile = useSelector(state => state.file.isLoadingFile);

  const isReadOnlyVisible = () => {
    return fileInfo && showReadOnly;
  };

  const isFileInfoVisible = () => {
    return fileInfo && showFileInfo;
  };

  const isChatVisible = () => {
    return fileInfo && showChat;
  };

  return (
    <>
      {/* Loader */}
      {isLoadingFile && <SpinnerBlack />}

      {!isEmpty(fileInfo) && (
        <div className="tool-bar">
          <div className="tabs">
            {/* Data Entry */}
            <div
              className={classnames("tab", "tab-menu-one", {
                selected: showReadOnly
              })}
            >
              <Link
                to="/"
                className="tab-menu"
                onClick={e => {
                  e.preventDefault();
                  setShowReadOnly(true);
                  setShowFileInfo(false);
                  setShowChat(false);
                }}
              >
                <i className="fas fa-database"></i>
              </Link>
            </div>

            {/* File Info */}
            <div
              className={classnames("tab", "tab-menu-three", {
                selected: showFileInfo
              })}
            >
              <Link
                to="/"
                className="tab-menu"
                onClick={e => {
                  e.preventDefault();
                  setShowReadOnly(false);
                  setShowFileInfo(true);
                  setShowChat(false);
                }}
              >
                <i className="fas fa-info-circle"></i>
              </Link>
            </div>

            {/* Chat*/}
            <div
              className={classnames("hide tab", "tab-menu-four", {
                selected: showChat
              })}
            >
              <Link
                to="/"
                className="tab-menu"
                onClick={e => {
                  e.preventDefault();
                  setShowReadOnly(false);
                  setShowFileInfo(false);
                  setShowChat(true);
                }}
              >
                <i className="fas fa-comments"></i>
              </Link>
            </div>
          </div>

          <div className="tab-content-wrapper">
            <ReadOnly isHidden={!isReadOnlyVisible()} />
            <FileInfo isHidden={!isFileInfoVisible()} />
            <Chat
              isHidden={!isChatVisible()}
              onSend={() => {
                setShowChat(false);
                setShowReadOnly(true);
              }}
            />
          </div>
        </div>
      )}

      {/* No File Selected */}
      {(!fileInfo || isEmpty(fileInfo)) && (
        <div className="center">{Translate({ id: "no_file_selected" })} </div>
      )}
    </>
  );
};

export default ToolBar;
